import { render, staticRenderFns } from "./date-picker.vue?vue&type=template&id=fb008988"
import script from "./date-picker.vue?vue&type=script&lang=ts"
export * from "./date-picker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports